import { Component, OnInit } from '@angular/core';

import { EmitterService } from '../../../../core/utility/services/emitter.service';
import { EVENT_EMITTERS } from '../../../analytics/constants/analytics.constants';
import { AnalyticsService } from '../../../analytics/services/analytics.service';
import { GeofenceAppsComponent } from '../geofence-apps/geofence-apps.component';

@Component({
	selector: 'app-geofence-apps-r6',
	styleUrls: ['./geofence-apps-r6.component.css'],
	templateUrl: './geofence-apps-r6.component.html'
})
export class GeofenceAppsR6Component extends GeofenceAppsComponent implements OnInit {
	constructor(protected analyticsService: AnalyticsService) {
		super(analyticsService);
		this.geofenceAppData = [];
		this.reloadSubscription = EmitterService.get(EVENT_EMITTERS.RELOAD).subscribe(() => {
			this.requestData();
		});
	}

	ngOnInit(): void {
		super.ngOnInit();
	}
}
